// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__z_XxK","title":"AfterFrontImage_title__1GmYD"};